import { useEffect, useRef } from 'react'
import QR from 'qrcode'

export const useQRCodeCanvas = (url: string) => {
  const canvasEl = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (canvasEl?.current) {
      const previewOptions: QR.QRCodeRenderersOptions = {
        margin: 0,
        width: 200,
      }

      QR.toCanvas(canvasEl.current, url, previewOptions, error => {
        if (error) return console.error(error)
      })
    }
  }, [url, canvasEl])

  return canvasEl
}
